import { InfoBlockModel } from '../../models/view.models';
import { ResourceItem } from 'sos-common/js/commonTypes/resourceItem';

export interface IYrkesValProps {
  model: Model;
  isEditMode: boolean;
  translations: ResourceItem[];
}

export interface IUtbildningsValProps {
  currentYrke?: Location;
  translations: ResourceItem[];
  legitimationFormUrl: string;
}

export interface IUtbildningsValState {
  currentLocation?: Location;
}
export interface IYrkesValState {
  currentYrke?: SpecialistKompetensYrken;
  currentLocation?: Location;
}

/**
 * Do not change string values since the property names for
 * EpiserverProperty component is generated using these strings
 */
export enum SpecialistKompetensYrken {
  Lakare = 'Lakare',
  Tandlakare = 'Tandlakare',
  Sjukskoterska = 'Sjukskoterska',
  Sjukhusfysiker = 'Sjukhusfysiker',
}

/**
 * Do not change string values since the property names for
 * EpiserverProperty component is generated using these strings
 */
export enum Location {
  Swe = 'Sweden',
  Eu = 'Eu',
  NonEu = 'NonEu',
  NonEu3Year = 'NonEu3Year',
}

/**
 * Propert names must match with
 * \Legitimation\Models\ViewModels\Legitimation\Specialistkompetens\YrkesvalViewModel.cs -> ReactModel
 */
export interface Model {
  Lakare: DetailModel;
  Tandlakare: DetailModel;
  Sjukskoterska: DetailModel;
  Sjukhusfysiker: DetailModel;
  Warning: InfoBlockModel;
  InfoBubble: string;
  PickYrkeHeader: string;
  ChooseLocationHeader: string;
}

/**
 * Propert names must match with
 * \Legitimation\Models\ViewModels\Legitimation\Specialistkompetens\YrkesvalViewModel.cs -> SpecialistKompetens
 */
export interface DetailModel {
  Sweden: string;
  Eu: string;
  NonEu: string;
  NonEuNonEu3Year: string;
}
